import React from 'react';
import PropTypes from 'prop-types';
import FooterLinkWrapper from './FooterLinkWrapper';
import { Mobile } from '../../MediaQuery';
import { useUrlBuilder } from '../../../hooks/useUrlBuilder';

const FooterLinks = ({ code, links }) => {
  const { localized } = useUrlBuilder();
  return (
    <>
      {links.map((link, index) => {
        const linkId = `${code}-${index}`;
        const { title, url } = link;
        return (
          <a key={linkId} id={linkId} href={url.startsWith('http') ? url : localized(`${url}`)}>
            <FooterLinkWrapper>
              <Mobile> &bull; </Mobile>
              {title}
            </FooterLinkWrapper>
          </a>
        );
      })}
    </>
  );
};
FooterLinks.propTypes = {
  code: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default FooterLinks;
